export default "__VITE_ASSET__3aIF0UAO__"